module.exports = __webpack_public_path__ + "static/media/photo1.aa57deaa.jpg";